module.exports = __webpack_public_path__ + "img/7.4946d207.png";